import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AuthService } from './auth.service';

export interface SentryLoggingContext {
  tags?: Record<string, string | boolean>;
  fingerprint?: string[];
  level?: Sentry.SeverityLevel;
}

@Injectable({
  providedIn: 'root',
})
export class SentryService {
  constructor(private readonly authService: AuthService) {}

  captureException(error: unknown, context: SentryLoggingContext = {}): string {
    return Sentry.captureException(error, {
      ...context,
      tags: { ...this.getAuthContextTags(), ...context.tags },
    });
  }

  captureMessage(message: string, context: SentryLoggingContext = {}): string {
    return Sentry.captureMessage(message, {
      ...context,
      tags: { ...this.getAuthContextTags(), ...context.tags },
    });
  }

  private getAuthContextTags(): Record<string, string> {
    try {
      const tenant = this.authService.getTenant();
      const user = this.authService.getUser();
      return {
        tenantId: tenant?.id ?? 'unknown',
        tenantType: tenant?.type ?? 'unknown',
        userId: user?.id ?? 'unknown',
      };
    } catch (error) {
      console.warn('Unable to read auth context for Sentry reporting:', error);
      return {};
    }
  }
}
